import React from 'react';

const MapKey = () => {
  return (
    <div className="station-map-legend__container">
      <div className="station-map-legend__content">
        <section className="station-map-legend__section">
          <h3 className="station-map-legend__title">Air quality rating</h3>
          <ol className="station-map-rating-legend__list">
            <li className="station-map-rating-legend__list-item">
              <span className="station-map-rating-legend__icon icon-good"></span>Good
            </li>
            <li className="station-map-rating-legend__list-item">
              <span className="station-map-rating-legend__icon icon-fair"></span>Fair
            </li>
            <li className="station-map-rating-legend__list-item">
              <span className="station-map-rating-legend__icon icon-poor"></span>Poor
            </li>
            <li className="station-map-rating-legend__list-item">
              <span className="station-map-rating-legend__icon icon-very-poor"></span>Very poor
            </li>
            <li className="station-map-rating-legend__list-item">
              <span className="station-map-rating-legend__icon icon-extremely-poor"></span>Extremely poor
            </li>
            <li className="station-map-rating-legend__list-item">
              <span className="station-map-rating-legend__icon icon-inactive"></span>Inactive
            </li>
          </ol>
        </section>
        <section className="station-map-legend__section">
          <h3 className="station-map-legend__title">Station purpose</h3>
          <ul className="station-map-purpose-legend__list">
            <li className="station-map-purpose-legend__list-item">
              <span className="station-map-purpose-legend__icon icon-contributes"></span>Contributes to region rating
            </li>
            <li className="station-map-purpose-legend__list-item">
              <span className="station-map-purpose-legend__icon icon-excluded"></span>Excluded from region rating
            </li>
          </ul>
        </section>
      </div>
    </div>
  );
};

export default MapKey;